angular
  .module 'memberPortal'
  .controller 'ShowEventCtrl', (
    $scope,
    $state,
    $stateParams,
    $http,
    $window,
    $modal,
    DataService,
    $filter,
    MessageService,
    event
  ) ->
    $scope.data = DataService
    $scope.hash = $stateParams.m
    $scope.origin = $stateParams.origin
    domain = $scope.data.domain
    $scope.event = event

    getBookAllLimits = ->
      url = "/websites/#{DataService.domain}/members/events/#{$scope.event.id}/book_all_limits"
      $http.get(url).then (response) ->
        $scope.bookAllLimits = response.data
    getBookAllLimits()

    reloadEvent = ->
      getBookAllLimits()
      $scope.isLoading = true
      url = "/websites/#{DataService.domain}/members/events/#{$scope.event.id}"
      $http.get(url).then (response) ->
        $scope.isLoading = false
        $scope.event = response.data
      , () ->
        $scope.isLoading = false

    clearMessages = ->
      $scope.error = ''

    $scope.isBooked = ->
      $scope.event.member_portal_booking_status in ['Booked', 'Absent', 'Attended']

    parseTime = (time, event)->
      if event.event_tz_type is 'browser'
        moment.utc(time, 'YYYY/MM/DD HH:mm').local()
      else
        moment(time, 'YYYY/MM/DD HH:mm')

    isPastEvent = ->
      endMoment = parseTime($scope.event.end_at, $scope.event)
      moment().isSameOrAfter(endMoment, 'minute')

    $scope.isFutureEventsAvailable = ->
      $scope.bookAllLimits?.event_count > 1

    $scope.isCancelAvailable = ->
      $scope.isBooked() && $scope.event.cancellable &&
        $scope.event.cancellable_by_member && !isPastEvent()

    $scope.isLateCancelAvailable = ->
      $scope.isBooked() && !$scope.isCancelAvailable() &&
        $scope.event.allow_late_cancellations

    $scope.lateCancellationFeeExists = ->
      !!parseFloat($scope.event.late_cancellation_fee)

    $scope.lateCancelBooking = ->
      message = if $scope.lateCancellationFeeExists()
        fee = $filter('currency')($scope.event.late_cancellation_fee, $scope.data.currency)
        "Please note: A fee of #{fee} applies to late cancellations for this class."
      else
        undefined

      if isPastEvent()
        $scope.error = 'Cannot cancel a booking in the past.'
        window.scrollTo(0, 0)
        return

      messageParams =
        title: 'Are you sure you want to cancel this booking?'
        message: message
        confirmButtonText: 'Yes'
        cancelButtonText: 'No'

      MessageService.message(messageParams).then () ->
        bookingId = $scope.event.member_portal_booking_id
        url = "/websites/#{domain}/members/bookings/#{bookingId}/late_cancel"
        $scope.isLoading = true
        $http.delete(url).then (data) ->
          reloadEvent()
        , (response) ->
          $scope.isLoading = false
          $scope.error = response.data.error

    $scope.cancelBooking = ->
      if isPastEvent()
        $scope.error = 'Cannot cancel a booking in the past.'
        window.scrollTo(0, 0)
        return

      messageParams =
        title: 'Are you sure you want to cancel this booking?'
        confirmButtonText: 'Yes'
        cancelButtonText: 'No'

      MessageService.message(messageParams).then () ->
        clearMessages()
        bookingId = $scope.event.member_portal_booking_id
        url = "/websites/#{domain}/members/bookings/#{bookingId}"
        $scope.isLoading = true
        $http.delete(url).then (data) ->
          reloadEvent()
        , (response) ->
          $scope.isLoading = false
          $scope.error = response.data.error

    $scope.isBookingAvailable = ->
      if DataService.block_bookings_before_hour
        parseInt(moment(new Date()).format("HH")) >= DataService.block_bookings_before_hour

    $scope.displayAvailableTimeForBooking = ->
      blockBookingsBeforeHour = "#{DataService.block_bookings_before_hour}:00"
      moment(blockBookingsBeforeHour, "HH:mm").format("h:mm a")

    $scope.bookIn = ->
      clearMessages()
      url = "/websites/#{domain}/members/bookings"
      $scope.isLoading = true
      $http.post(url, booking: {event_id: event.id}).then (data) ->
        reloadEvent()
      , (response) ->
        $scope.isLoading = false
        $scope.error = response.data.error

    $scope.joinWaitlist = ->
      clearMessages()
      params =
        event_id: $scope.event.id
        contact_id: DataService.member_details.id
      url = "/websites/#{domain}/members/waitlist_attendees"
      $scope.isLoading = true
      $http.post(url, params).then (data) ->
        reloadEvent()
      , (response) ->
        $scope.isLoading = false
        $scope.error = response.data.error

    $scope.leaveWaitlist = ->
      if $window.confirm "Leave waitlist for this event?"
        clearMessages()
        id = $scope.event.waitlist_attendee_id
        url = "/websites/#{domain}/members/waitlist_attendees/#{id}"
        $scope.isLoading = true
        $http.delete(url).then (data) ->
          reloadEvent()
        , (response) ->
          $scope.isLoading = false
          $scope.error = response.data.error

    $scope.bookAll = ->
      dateLimit = if $scope.bookAllLimits.date_limit
        $filter('date')($scope.bookAllLimits.date_limit)
      else
        null
      eventCount = $scope.bookAllLimits.event_count
      classPackLimit = $scope.bookAllLimits.class_pack_limit
      eventDate = $filter('date')($scope.event.start_date)
      futureBookingsCountLimit = $scope.bookAllLimits.future_bookings_count_limit
      futureBookingsDate = $filter('date')($scope.bookAllLimits.future_bookings_date_limit)
      futureBookingPlural = $filter('pluralize')('bookings', futureBookingsCountLimit)

      message = switch
        when !!futureBookingsCountLimit && !!$scope.bookAllLimits.future_bookings_date_limit
          [
            "Your membership allows you to hold up to #{futureBookingsCountLimit} #{futureBookingPlural} between now and #{futureBookingsDate}."
            "Would you like to continue?"
          ]
        when !!$scope.bookAllLimits.future_bookings_date_limit
          [
            "Your membership limits how far into the future classes can be booked."
            "This will book classes up to #{futureBookingsDate}, or until the membership expires."
            "Would you like to continue?"
          ]
        when !!futureBookingsCountLimit
          [
            "Your membership allows up to #{futureBookingsCountLimit} future #{futureBookingPlural} to be held at a time."
            "Would you like to continue?"
          ]
        when !!$scope.bookAllLimits.date_limit && !classPackLimit
          [
            "There are #{eventCount} #{$scope.event.name} events between #{eventDate} and when your membership expires, on #{dateLimit}."
            "Book all #{eventCount} events?"
          ]
        when !!classPackLimit && !$scope.bookAllLimits.date_limit
          [
            "Your membership(s) have #{classPackLimit} bookings remaining."
            "Book the next #{classPackLimit} events in this series?"
          ]
        when !!classPackLimit && !!$scope.bookAllLimits.date_limit
          [
            "Your membership(s) have #{classPackLimit} bookings remaining, and continue until #{dateLimit}. This will book the next #{classPackLimit} events in this series, or up to your membership expiry date - whichever happens sooner."
            "Would you like to continue?"
          ]
        else
          [
            "There are #{eventCount} #{$scope.event.name} events remaining in this series."
            "Book all #{eventCount} events?"
          ]

      modalInstance = $modal.open
        template: require('templates/member_portal/events/book_all_modal.html.slim')
        windowClass: 'message-modal'
        resolve:
          message: -> message
        controller: ($scope, $modalInstance, message) ->
          $scope.message = message
          $scope.title = 'Book all events'
          $scope.state = 'initial'

          $scope.displayEventTime = (event) ->
            dateTime = moment(event.start_at)
            time = dateTime.format('h:mma')
            date = dateTime.format('D-MMM-YYYY')
            "#{time} on #{date}"

          $scope.getBookedEventsCount = ->
            $scope.bookedEvents.length

          $scope.getFirstBookedEventDate = ->
            return unless $scope.bookedEvents.length
            event = $scope.bookedEvents[0]
            $scope.displayEventTime(event)

          $scope.getLastBookedEventDate = ->
            return unless $scope.bookedEvents.length
            event = _.last $scope.bookedEvents
            $scope.displayEventTime(event)

          $scope.submit = () ->
            $scope.state = 'loading'
            url = "/websites/#{domain}/members/bulk_bookings"
            $http.post(url, booking: {event_id: event.id}).then (response) ->
              $scope.state = 'success'
              $scope.bookedEvents = response.data.bookings?.valid
              $scope.title = "You're booked in!"
            , (response) ->
              defaultMessage =
                "Sorry, we are unable to book all remaining events at this time"
              $scope.error = response.data.message || defaultMessage
              $scope.invalidBookings = response.data.bookings?.invalid
              $scope.state = 'error'
              $scope.title = "Unable to book"

          $scope.close = ->
            modalInstance.close()

      modalInstance.result.then ->
        reloadEvent()

    $scope.getDate = ->
      parseTime($scope.event.start_at, $scope.event).format('ddd, D MMMM, YYYY')

    $scope.getTime = ->
      start = parseTime($scope.event.start_at, $scope.event).format('h:mma')
      end = parseTime($scope.event.end_at, $scope.event).format('h:mma')
      "#{start} - #{end}"
